import angular from 'angular';
import { aiAgentTabsComponents } from './tabs';
import { aiAgentCommonComponents } from './common';
export const aiAgentComponents = angular
    .module('aiAgentComponents', [aiAgentTabsComponents, aiAgentCommonComponents])
    .name;
